export var isSupportWebp = function () {
    try {
        return document.createElement('canvas').toDataURL('image/webp', 0.5)
            .indexOf('data:image/webp') === 0;
    }
    catch (err) {
        return false;
    }
};
// 判断图片连接中是否包含?
export var hasImageFormat = function (url) {
    var pattern = /\?/i;
    return pattern.test(url);
};
var formateImageUrl = function () {
    var isSupport = isSupportWebp();
    var imageWebp = 'imageMogr2/format/webp';
    return function (url) {
        if (isSupport) {
            return hasImageFormat(url) ? url + "&" + imageWebp : url + "?" + imageWebp;
        }
        return url;
    };
};
export var formateImageWebp = formateImageUrl();
